/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SummaryMortiDTO
 */
export interface SummaryMortiDTO {
    /**
     * 
     * @type {number}
     * @memberof SummaryMortiDTO
     */
    numeroMorti?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryMortiDTO
     */
    percentualeMorti?: number | null;
}

/**
 * Check if a given object implements the SummaryMortiDTO interface.
 */
export function instanceOfSummaryMortiDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SummaryMortiDTOFromJSON(json: any): SummaryMortiDTO {
    return SummaryMortiDTOFromJSONTyped(json, false);
}

export function SummaryMortiDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryMortiDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numeroMorti': !exists(json, 'numeroMorti') ? undefined : json['numeroMorti'],
        'percentualeMorti': !exists(json, 'percentualeMorti') ? undefined : json['percentualeMorti'],
    };
}

export function SummaryMortiDTOToJSON(value?: SummaryMortiDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'numeroMorti': value.numeroMorti,
        'percentualeMorti': value.percentualeMorti,
    };
}

